/**
 * @generated SignedSource<<25e0fe620cd7b71380b775af2be62584>>
 * @relayHash 707e1dbb8f70a1dd1b26c3b4a19d5d31
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 707e1dbb8f70a1dd1b26c3b4a19d5d31

import { ConcreteRequest } from 'relay-runtime';
export type useOnHasUnreadMessagesChangedSubscription$variables = Record<PropertyKey, never>;
export type useOnHasUnreadMessagesChangedSubscription$data = {
  readonly onHasUnreadMessagesChanged: {
    readonly hasUnreadMessages: boolean;
  };
};
export type useOnHasUnreadMessagesChangedSubscription = {
  response: useOnHasUnreadMessagesChangedSubscription$data;
  variables: useOnHasUnreadMessagesChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ChatHasUnreadMessagesChanged",
    "kind": "LinkedField",
    "name": "onHasUnreadMessagesChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasUnreadMessages",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useOnHasUnreadMessagesChangedSubscription",
    "selections": (v0/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useOnHasUnreadMessagesChangedSubscription",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "707e1dbb8f70a1dd1b26c3b4a19d5d31",
    "metadata": {},
    "name": "useOnHasUnreadMessagesChangedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "c72841caa49beb733e7a4ed862c7a193";

export default node;
